import { useState } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import styles from './MobileApp.module.css';
import BottomNav from './components/BottomNav';
import CabinTab from './tabs/CabinTab';
import BroadcastTab from './tabs/BroadcastTab';
import TreasureTab from './tabs/TreasureTab';
import ProfileTab from './tabs/ProfileTab';

export type MobileTabKey = 'cabin' | 'broadcast' | 'treasure' | 'profile';

function MobileApp() {
  const [activeTab, setActiveTab] = useState<MobileTabKey>('cabin');

  return (
    <ConfigProvider
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorPrimary: '#00ffff',
          colorInfo: '#00ffff',
          colorBgContainer: 'rgba(10, 22, 44, 0.92)',
          colorBgElevated: 'rgba(10, 22, 44, 0.98)',
          colorBorder: 'rgba(0, 255, 255, 0.18)',
          fontFamily: "'PingFang SC', 'Microsoft YaHei', sans-serif",
        },
      }}
    >
      <div className={styles.shell}>
        <div className={styles.content}>
          {activeTab === 'cabin' && <CabinTab />}
          {activeTab === 'broadcast' && <BroadcastTab />}
          {activeTab === 'treasure' && <TreasureTab />}
          {activeTab === 'profile' && <ProfileTab />}
        </div>
        <BottomNav active={activeTab} onChange={setActiveTab} />
      </div>
    </ConfigProvider>
  );
}

export default MobileApp;
